import './../styles/user-details.scss';

export default /* @ngInject */ class {

    constructor(authService, PaymentProfileResource, moment) {

        this.$loading = true;

        this.paymentProfileResource = PaymentProfileResource;

        this.activeplans = false;

        this.currentProduct = null;
        this.transactions = null;
        this.nextBilldate = null;

        this.dependencies = {
            authService: authService
        };

        this.paymentProfileResource.getProfile().$promise.then((data) => {

            if (data.subscribed_products.length !== 0) {
                this.activeplans = true;
            }
            else {
                this.$loading = false;
                return;
            }

            this.currentProduct = data.subscribed_products.find((product) => {
                //TODO: Ability to get more info about product group
                return (product.is_active);
            });

            this.cards = data.cards;

            if (this.currentProduct && this.cards.length > 0) {
                if (this.currentProduct.next_billing_date) {
                    this.nextBillDate = moment(this.currentProduct.next_billing_date).format('LL');
                    this.nextBillAmount = this.currentProduct.next_billing_amount;
                    this.currency = this.currentProduct.currency_symbol;
                }
            } else {
                this.activeplans = false;
            }
            this.$loading = false;
        });

        this.paymentProfileResource.transactions().$promise.then((data) => {
            this.transactions = data;
        });
    }
}



// WEBPACK FOOTER //
// ./user/payments-profile/payments-profile.js